import { Helmet } from "react-helmet-async"
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import FilterBar from "../../components/FilterBar/FilterBar"
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";
import { changePageSizeDocumentCenter, getDocumentCenterProducts, getDownloadDocumentCenter, getListaDocumentCenter, loadEmptyDocumentCenter } from "../../store/documentCenter/actions";
import { connect } from "react-redux";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import useLimitedRowSelection from "../../customHooks/useLimitedRowSelection";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import PillModal from "../../components/PillModal/PillModal";
import { Pill } from "../../components/Pill/Pill";
import { useEffect, useState } from "react";
import { DownloadLimitInfo } from "../../components/DownloadLimitInfo/DownloadLimitInfo";
import downloadBase64File from "../../helpers/downloadBase64File";
import useAlert from "../../customHooks/useAlert";
import moment from "moment";
import downloadDocuments from "../../helpers/downloadDocuments";
import ActionList from "../../components/ActionList/ActionList";
import { MAX_ROW_SELECTION, PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const DocumentCenter = ({
  getListaDocumentCenter,
  listaDocumentCenter,
  loadingDocumentCenter,
  pageSizeDocumentCenter,
  changePageSizeDocumentCenter,
  getDownloadDocumentCenter,
  

  getDocumentCenterProducts,
  documentCenterProducts,
  loadingDocumentCenterProducts,
  errorDocumentCenterProducts,

  documentCenterDownload,
  errorDocumentCenterDownload,
  loadEmptyDocumentCenter
}) => {
  const [objFilter, setObjFilter] = useState({
    searchText: null,
    createDateStart: null,
    createDateEnd: null,
    updateDateStart: null,
    updateDateEnd: null,
    regions: [],
    business: [],
    products: [],
  });
  const [loadingDownload, setLoadingDownload] = useState(false);
  
  const isFirstRender = useIsFirstRender();
  const { selectedRows, handleRowSelectionChange, selectedCount, clearSelection } = useLimitedRowSelection(MAX_ROW_SELECTION);
  const { successAlert, errorAlert } = useAlert();

  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeDocumentCenter,
    page: 0,
  });
  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeDocumentCenter(pageSize);

    getListaDocumentCenter({
      pageNumber: page + 1,
      pageSize: pageSize,
      searchText: objFilter.searchText,
      createDateStart: objFilter.createDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateStart: objFilter.updateDateStart,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
    });
  };
  const handleSortChange = (model) => {
    console.log(model);
  };
  const handleDocumentDownloadPDF = (e, documentId) => {
    e.stopPropagation();
    setLoadingDownload(true);
    getDownloadDocumentCenter({
      documentId: documentId,
      type: "pdf",
    });
  };

  const columns = [
    {
      field: "title",
      headerName: "Document Title",
      flex: 3,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "createDate",
      headerName: "Creation date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "regionName",
      headerName: "Region",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "businessName",
      headerName: "Business",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "totalProducts",
      headerName: "Products",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalProducts}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M272 32L368 32C385.7 32 400 46.3 400 64C400 81.7 385.7 96 368 96L272 96C254.3 96 240 81.7 240 64C240 46.3 254.3 32 272 32zM176 208C176 172.7 204.7 144 240 144L400 144C435.3 144 464 172.7 464 208C464 232.1 450.7 253.1 431 264C450.7 274.9 464 295.9 464 320C464 344.1 450.7 365.1 431 376C450.7 386.9 464 407.9 464 432C464 456.1 450.7 477.1 431 488C450.7 498.9 464 519.9 464 544C464 579.3 435.3 608 400 608L240 608C204.7 608 176 579.3 176 544C176 519.9 189.3 498.9 209 488C189.3 477.1 176 456.1 176 432C176 407.9 189.3 386.9 209 376C189.3 365.1 176 344.1 176 320C176 295.9 189.3 274.9 209 264C189.3 253.1 176 232.1 176 208z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantityProducts(params.row.id);
          }}
          loading={loadingDocumentCenterProducts}
          data={documentCenterProducts}
          error={errorDocumentCenterProducts}
          view="document" //View que estamos singular
          variant="Products" //Variante no plural
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <ActionList 
          id={params.row.id}
          title={params.row.title}
          onDownloadDocumentCenter={handleDocumentDownloadPDF}
          variant="documentsCenter"
        />
      ),
    },
  ]
  const fetchQuantityProducts = (documentId) => {
    getDocumentCenterProducts({ documentId });
  };
  const handleDownloadDocuments = async () => {
    try {
      setLoadingDownload(true);
      const documentIds = Array.from(selectedRows.ids);
      if (documentIds.length === 0) return;
      
      const fileName = `Documents_${moment().format("YYYYMMDD")}.zip`;
      const success = await downloadDocuments(documentIds, fileName, "DocumentCenter");
      if (success) {
        successAlert("Documents .zip downloaded successfully");
      }
    } catch (err) {
      errorAlert(err.message);
    } finally {
      setLoadingDownload(false);
    }
  };

  useEffect(() => {
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
  
      getListaDocumentCenter({
        pageNumber: 1,
        pageSize: paginationModel.pageSize,
        searchText: objFilter.searchText,
        createDateStart: objFilter.createDateStart,
        createDateEnd: objFilter.createDateEnd,
        updateDateStart: objFilter.updateDateStart,
        updateDateEnd: objFilter.updateDateEnd,
        regions: objFilter.regions,
        business: objFilter.business,
        products: objFilter.products,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objFilter]);
  useEffect(() => {
      async function handleDownload() {
        if (documentCenterDownload) {
          const { base64, fileName, extension } = documentCenterDownload;
          const success = await downloadBase64File(base64, fileName, extension);
  
          if (success) {
            successAlert("Document downloaded successfully", {
              didClose: () => {
                loadEmptyDocumentCenter();
                setLoadingDownload(false);
              },
            });
          }
  
          return;
        }
  
        if (errorDocumentCenterDownload) {
          errorAlert(errorDocumentCenterDownload || "Try again later!", {
            didClose: () => {
              loadEmptyDocumentCenter();
              setLoadingDownload(false);
            },
          });
        }
      }
  
      handleDownload();
    
        // eslint-disable-next-line
  }, [documentCenterDownload, documentCenterDownload]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Document Center</title>
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
          <Card>
            <CardBody>
              <Row>
                <h2>DOCUMENT CENTER</h2>
              </Row>
              <Row>
                <Col md={12}>
                  <FilterBar 
                    placeholderSearch="Search by content"
                    setObjFilter={setObjFilter}
                    isFirstRender={isFirstRender}
                    variant="documentsCenter"
                  />                
                </Col>
              </Row>

              <Row>
                {loadingDocumentCenter || loadingDownload ? (
                  <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: 400, width: "100%" }}
                    >
                      <Spinner
                        color="primary"
                        style={{ height: "5rem", width: "5rem" }}
                      />
                    </div>
                ) : (
                  <>
                      <div className="d-flex align-center justify-content-end gap-2 mb-3">
                        <ButtonCustom 
                          type="download_OP2"
                          onClick={handleDownloadDocuments}
                          disabled={selectedCount === 0 || selectedCount > MAX_ROW_SELECTION}
                        />
                        {selectedCount > 0 && (
                          <ButtonCustom
                            type="clear"
                            onClick={clearSelection}
                          >
                          </ButtonCustom>
                        )}
                      </div>
                      
                      <DownloadLimitInfo selectedCount={selectedRows.ids.size} max={MAX_ROW_SELECTION}/>
                      
                      <CustomDatatable
                        columns={columns}
                        rows={listaDocumentCenter.records}
                        pagination
                        paginationMode="server"
                        rowCount={listaDocumentCenter?.totalRecords ?? 0}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handlePageChange}
                        onSortModelChange={handleSortChange}
                        pageSizeOptions={PAGE_SIZE_OPTIONS}
                        disableColumnFilter
                        disableColumnMenu
                        maxRowSelection={MAX_ROW_SELECTION}
                        checkboxSelection={true}
                        rowSelectionModel={selectedRows}
                        onRowSelectionModelChange={(model) =>
                          handleRowSelectionChange(model, listaDocumentCenter.records)
                        }
                        isRowSelectableForStatus={false}
                      />
                    </>
                )}
              </Row>
            </CardBody>
          </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
};

const mapStateToProps = ({
  DocumentCenterReducer: {
    listaDocumentCenter,
    loadingDocumentCenter,
    filterDocumentCenter,
    messageDocumentCenter,
    cleanMessageDocumentCenter,
    pageSizeDocumentCenter,

    documentCenterProducts,
    loadingDocumentCenterProducts,
    errorDocumentCenterProducts,

    documentCenterDownload,
    errorDocumentCenterDownload,
    
  },
}) => ({
  listaDocumentCenter,
  loadingDocumentCenter,
  filterDocumentCenter,
  messageDocumentCenter,
  cleanMessageDocumentCenter,
  pageSizeDocumentCenter,

  documentCenterProducts,
  loadingDocumentCenterProducts,
  errorDocumentCenterProducts,

  documentCenterDownload,
  errorDocumentCenterDownload,
  
});

const mapDispatchToProps = {
  getListaDocumentCenter: getListaDocumentCenter.request,
  getDownloadDocumentCenter: getDownloadDocumentCenter.request,
  getDocumentCenterProducts: getDocumentCenterProducts.request,
  changePageSizeDocumentCenter,
  loadEmptyDocumentCenter,
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentCenter);